<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header
    [label]="'MENUBAR.ALERT_POLYGON' | translate: {strNatNai: strNatNai, natNaiId: (alertPolygonObj.NaiNatId == 0) ? '' : alertPolygonObj.NaiNatId}"
    [dialogRef]='dialogRef' (mousedown)="windowClick()" [object]='this'>
  </dialog-header>
  <mat-dialog-content style="min-width: 390px; min-height: 250px;">
    <div fxLayout="column">
      <mat-grid-list cols="3" rowHeight="60px">
        <mat-grid-tile colspan="3">
          <mat-radio-group [(ngModel)]="alertPolygonObj.NaiOrNat" [disabled]="alertPolygonObj.OperationAction == 1">
            <mat-radio-button [value]=1 class="radio-button">{{'NAT_NAI.NAI' | translate}}</mat-radio-button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <mat-radio-button [value]=2 class="radio-button">{{'NAT_NAI.NAT' | translate}}</mat-radio-button>
          </mat-radio-group>
        </mat-grid-tile>
      </mat-grid-list>
      <mat-grid-list cols="2" rowHeight="90px" [formGroup]="Form">
        <mat-grid-tile>
          <mat-form-field class="mat-form-field-mega">
            <input matInput [disabled]="alertPolygonObj.OperationAction == 1" [placeholder]="'NAT_NAI.SIC' | translate"
              [@blinkError]="blinkAnimErrSic ? 'red' : 'noraml'" type="number" class="credibility-input"
              formControlName="sic" autocomplete="off" (input)="activeAnimErrSic = false">
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-form-field class="mat-form-field-mega">
            <input matInput [disabled]="alertPolygonObj.OperationAction == 1" [placeholder]="'NAT_NAI.SAC' | translate"
              [@blinkError]="blinkAnimErrSac ? 'red' : 'noraml'" type="number" class="credibility-input"
              formControlName="sac" autocomplete="off" (input)="activeAnimErrSac = false">
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-form-field class="mat-form-field-mega">
            <input matInput type="number" class="credibility-input" formControlName="minalt" autocomplete="off"
              [placeholder]="'NAT_NAI.MIN_ALTITUDE' | translate" [@blinkError]="blinkAnimErrMinAlt ? 'red' : 'noraml'"
              (input)="activeAnimErrMinAlt = false">
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-form-field class="mat-form-field-mega">
            <input matInput type="number" class="credibility-input" formControlName="maxalt" autocomplete="off"
              [placeholder]="'NAT_NAI.MAX_ALTITUDE' | translate" [@blinkError]="blinkAnimErrMaxAlt ? 'red' : 'noraml'"
              (input)="activeAnimErrMaxAlt = false">
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
      <div style="text-align: center; align-self: center;">
        <div class="aro-label-clickable" (click)="changeMetricSystem()">({{Units}})</div>
      </div>
      <p></p>
      <div style="text-align: center;">
        <mat-radio-group [(ngModel)]="alertPolygonObj.GeometricShape"
          [disabled]="alertPolygonObj.OperationAction == 1 || isActiveTool == true">
          <label>{{'NAT_NAI.GEOMETRIC_SHAPE' | translate}}</label><br><br>
          <mat-radio-button [value]=0 class="radio-button">{{'NAT_NAI.POLYGON' | translate}}</mat-radio-button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <mat-radio-button [value]=1 class="radio-button">{{'NAT_NAI.CIRCLE' | translate}}</mat-radio-button>
          &nbsp;&nbsp;&nbsp;&nbsp;
        </mat-radio-group><br><br>
        <div class="div-button-surr" [@blinkError]="blinkAnimErrGeo ? 'red' : 'noraml'">
          <button mat-stroked-button [disabled]="isActiveTool == true"
            [@blinkError]="blinkAnimErrGeo ? 'red' : 'noraml'" (click)="onDrawShapeClick()">{{buttonText}}</button>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="saveNaiParameters()">{{'ACTIONS.SAVE' | translate}}</button>
    </mat-dialog-actions>
  </mat-dialog-content>
</div>